import {useMutation} from "@tanstack/react-query";
import {downloadFile} from "../../../../../util/FileDownload";
import {downloadProductImage} from "../../../../../api/product/ProductExApi";

export const useDownloadProductImageEx = () => {
    const {mutate} = useMutation({
        mutationFn: (data: { fileId: number; fileKey: string; fileOrgname: string }) => downloadProductImage(data),
        onSuccess: (res, variables) => {
            if (res instanceof Blob) {
                downloadFile(res, variables.fileOrgname)
            }
        },
    });

    return {mutate};
};
